module.exports = __webpack_public_path__ + "img/24.0bdf9a1e.svg";